/**
 * Centralized storage hook that automatically selects the right storage method
 * based on the current context (widget mode vs normal mode)
 */

import { useLocalStorage } from "@uidotdev/usehooks";
import { useUniversalStorage } from "src/utils/widgetStorage";

export function useStorage<T>(key: string, initialValue: T) {
    // Check if we're in widget mode
    const urlParams = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.split("?")[1] || "");
    const isWidgetMode =
        urlParams.get("mode") === "widget" ||
        window.location.hash.includes("/widget/") ||
        window.location.hash.includes("/copilot") ||
        window.location.search.includes("mode=copilot") ||
        hashParams.get("auth") === "demo";

    // Call both hooks unconditionally to satisfy React's rules of hooks
    const universalStorage = useUniversalStorage(key, initialValue);
    const localStorage = useLocalStorage(key, initialValue);

    // Return the appropriate storage based on mode
    return isWidgetMode ? universalStorage : localStorage;
}

// Export common storage keys for consistency
export const STORAGE_KEYS = {
    IS_FORBIDDEN: "isForbidden",
    CHAT_PREFERENCES: "chatPreferences",
    SELECTED_ORGANIZATION: "selectedOrganization",
    LAST_LOGIN_TIME: "lastLoginTime",
    USER_SETTINGS: "userSettings",
} as const;
